/**
 * My Happy Helpers Experience System
 * Feature Experience reveal controller
 */

(() => {
  const selector = '[data-mhh-exp-features]';

  function initialiseFeatureExperience(section) {
    if (!(section instanceof HTMLElement)) return;

    if (section.dataset.mhhFeaturesInitialised === 'true') return;

    section.dataset.mhhFeaturesInitialised = 'true';

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      section.classList.add('is-revealed');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-revealed');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    observer.observe(section);
  }

  function initialiseAllFeatureExperiences(root = document) {
    root.querySelectorAll(selector).forEach(initialiseFeatureExperience);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initialiseAllFeatureExperiences();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllFeatureExperiences(event.target);
  });
})();